export default {
  CENTER_IF_NULL: {
    'text-center': 'x === null',
  },
  NUMBER: {
    'text-center': 'x === null',
    'text-right': 'x !== null',
  },
  NUMBER_FLEXBOX: {
    'justify-content-center': 'x === null',
    'justify-content-end': 'x !== null',
  },
};
